// @flow

import React, { Component } from 'react'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'
import type { Node } from 'react'
import color from 'michelangelo/dist/Components/styles/color'
import Bowser from 'bowser'

const MainParallax: ReactComponentStyled<{}> = styled.div`
  @media only screen and (min-width : 320px) and (max-width : 823px) {
    perspective: 1px;
    transform-style: preserve-3d;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: scroll;
  }
`
MainParallax.displayName = 'MainParallax'

const HeaderContainerParallax: ReactComponentStyled<{}> = styled.div`
  width: 100%;
  height: 300px;
  top: 0%;
  @media only screen and (min-width : 320px) and (max-width : 823px) {
    display: flex;
    top: -25vh;
    flex: 1 0 auto;
    position: relative;
    z-index: -1;
    height: 50vh;
    justify-content: center;
    align-items: flex-start;
    transform: translateZ(-1px) scale(2);
  }
  @media (orientation: portrait) {
    height: 55vh;
    top: -23vh;
  }
  @media only screen and (orientation: landscape) and (max-width : 832px) {
    height: 75vh;
    top: -13vh;
  }
`
HeaderContainerParallax.displayName = 'HeaderContainerParallax'

const BodyContainerParallax: ReactComponentStyled<{}> = styled.div`
  text-align: ${(props) => props.isRichText ? 'inherit' : 'center'};
  padding: 1%;

  @media only screen and (min-width : 320px) and (max-width : 823px) {
    position: relative;
    display: block;
    background-color: ${color.white};
    z-index: 1;
  }
`
BodyContainerParallax.displayName = 'BodyContainerParallax'

const Header: ReactComponentStyled<{}> = styled.div`
  width: 100%;
  top: 0%;
  @media only screen and (orientation: portrait) and (min-width : 320px) and (max-width : 480px) {
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 68.56%;
  }
`
Header.displayName = 'Header'

const Body: ReactComponentStyled<{}> = styled.div`
  text-align: ${(props) => props.isRichText ? 'inherit' : 'center'};
  padding: 1%;

  @media only screen and (orientation: portrait) and (min-width : 320px) and (max-width : 480px) {
    top: auto;
  }
`
Body.displayName = 'Body'

type LayoutProps = {
  header?: Node,
  body: Node,
  usePadding?: boolean,
  useParallax?: boolean,
  isRichText?: boolean
}
class Layout extends Component<LayoutProps, {}> {
  getHeader (isSafariMobile: boolean) {
    const { header, useParallax } = this.props
    if (!header) {
      return null
    }

    if (useParallax && !isSafariMobile) {
      return <HeaderContainerParallax>{header}</HeaderContainerParallax>
    } else {
      return <Header>{header}</Header>
    }
  }

  getBody (isSafariMobile: boolean) {
    const { body, usePadding, useParallax, isRichText } = this.props
    if (useParallax && !isSafariMobile) {
      return <BodyContainerParallax isRichText={isRichText}>{body}</BodyContainerParallax>
    } else {
      return <Body isRichText={isRichText} usePadding={usePadding}>{body}</Body>
    }
  }

  render () {
    const browser = Bowser.parse(window.navigator.userAgent)
    const isSafariMobile = browser.browser.name === 'Safari' && browser.platform.type === 'mobile'
    const { useParallax } = this.props
    const header = this.getHeader(isSafariMobile)
    const body = this.getBody(isSafariMobile)
    if (useParallax && !isSafariMobile) {
      return <MainParallax>{header}{body}</MainParallax>
    } else {
      return <div>{header}{body}</div>
    }
  }
}

export default Layout
